import { useEffect, useState } from "react";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import { Plus } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { HorseCard, HorseForm } from "@/components/stable/HorseProfile";
import { Agenda } from "@/components/stable/Agenda";
import { btnRed, dmy } from "@/components/stable/ui";
import { PushToggle } from "@/components/PushToggle";

export default function Stable() {
  const { user } = useAuth();
  const [params] = useSearchParams();
  const [horses, setHorses] = useState([]);
  const [events, setEvents] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => { api.get("/horses").then((r) => setHorses(r.data)); api.get("/events").then((r) => setEvents(r.data)); };
  useEffect(() => { if (user) load(); }, [user]);
  if (user === null) return <div className="py-32 text-center text-slate-500">Cargando…</div>;
  if (user === false) return <Navigate to="/login?next=/cuadra" replace />;
  const next = events.filter((e) => !e.done && e.date >= new Date().toISOString().slice(0, 10)).slice(0, 3);
  return (
    <div data-testid="stable-page">
      <section className="bg-[#0B1D3A] text-white">
        <div className="max-w-6xl mx-auto px-4 py-12">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#93C5FD] mb-3">Herramienta gratuita</p>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl uppercase">Mi cuadra</h1>
          <p className="text-blue-100 mt-3 max-w-2xl">La ficha de cada caballo, su calendario de salud y tus concursos, con avisos por email y en el móvil 7 días antes y el mismo día.</p>
          <PushToggle />
          {next.length > 0 && <div className="mt-6 flex flex-wrap gap-2" data-testid="stable-next">{next.map((e) => <span key={e.id} className="bg-white/10 rounded-full px-4 py-1.5 text-sm"><b>{dmy(e.date)}</b> · {e.title}</span>)}</div>}
        </div>
      </section>
      <div className="max-w-6xl mx-auto px-4 py-10">
        <Tabs defaultValue={params.get("tab") || "caballos"}>
          <TabsList className="bg-[#EFF6FF]">
            <TabsTrigger value="caballos" data-testid="stable-tab-horses">Mis caballos</TabsTrigger>
            <TabsTrigger value="calendario" data-testid="stable-tab-calendar">Calendario</TabsTrigger>
          </TabsList>
          <TabsContent value="caballos" className="pt-6">
            <div className="flex flex-wrap items-center gap-3 mb-6">
              <button onClick={() => setEdit("new")} className={btnRed} data-testid="stable-horse-new"><Plus size={17} /> Añadir caballo</button>
              <Link to="/concursos" className="text-sm font-bold text-[#2563EB] underline underline-offset-4">Ver calendario de concursos</Link>
            </div>
            {!horses.length && <p className="text-slate-500" data-testid="stable-empty">Aún no tienes caballos. Crea su ficha con datos, fotos, microchip, pasaporte, alzada y alimentación.</p>}
            <div className="grid md:grid-cols-2 gap-6">{horses.map((h) => <HorseCard key={h.id} h={h} reload={load} onEdit={() => setEdit(h)} />)}</div>
          </TabsContent>
          <TabsContent value="calendario" className="pt-6"><Agenda events={events} horses={horses} reload={load} /></TabsContent>
        </Tabs>
      </div>
      {edit && <HorseForm key={edit.id || "new"} horse={edit === "new" ? null : edit} open onClose={() => setEdit(null)} onSaved={() => { setEdit(null); load(); }} />}
    </div>
  );
}
